<template>
    <v-card v-bind="$attrs" outlined :rounded="rounded">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </v-card>
</template>

<script>
export default {
    props: {        
        rounded: { type: String, default: "" },
    },
    components: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
